export const FLYSHARE_ALL_ROUTE = "all";
export const FLYSHARE_OTHERS_ROUTE = "shared-with-others";
export const FLYSHARE_SHARED_ROUTE = "shared-with-me";
export const FLYCUT_OUTSIDE_PLAN_ALLOCATED = 10;
